
export default {
  props: {
    data: {},
    colShow: { type: Boolean, default: false },
  },
};
